export default "__VITE_ASSET__DXufyuJb__"